import { Dictionary } from "../../../utils/sys/Dictionary";
import KeyedValueSorter from "./KeyedValueSorter";
import Talent from "../../../utils/game/mechanics/Talent";

export type SortKey = "title" | "subtype" | "proficiency" | "description";

export default class TalentSorter extends KeyedValueSorter {
    protected static override valueGetters = new Dictionary<SortKey, (talent: Talent) => string | number>([
        { key: "title", value: (talent) => talent.title },
        { key: "subtype", value: (talent) => talent.subtype },
        { key: "proficiency", value: (talent) => talent.proficiency.length === 0 ? "" : talent.proficiency.join("") },
        { key: "description", value: (talent) => talent.description }
    ]);
}
